import { ReactElement } from 'react'

import { usePermissions } from '@percent/admin-dashboard/common/hooks/usePermissions'
import { PermissionGateProps } from './PermissionGate.types'

export function PermissionGate({ permissions, children, fallback = null }: PermissionGateProps): ReactElement | null {
  const { userHasPermissions, permissionsSet } = usePermissions()

  if (!permissionsSet) {
    return null
  }

  if (!userHasPermissions(permissions)) {
    return fallback as ReactElement | null
  }

  return children as ReactElement
}
